"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _layer = require("./layer");

var _layer2 = _interopRequireDefault(_layer);

var _eventservice = require("./eventservice");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import './index.less';
if (typeof window != "undefined") {
  var div = document.createElement("div");
  document.body.appendChild(div);

  _reactDom2.default.render(_react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(_layer2.default, null)
  ), div);
}

exports.default = _eventservice.T;
module.exports = exports["default"];